import React, { useEffect, useState } from 'react';

import { Card, CardContent, Stack, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { AccBadge } from './Badge/AccBadge';
import { LengthBadgeFeature } from './Badge/LengthBadge';
import { labelCnigSurface, labelCnigCondition } from 'handimap-react-lib/utils/cnigMapping';

export const CardInfoSection = ({selectedSection, typeAcc}) => {

  const [sectionProperties, setSectionProperties] = useState({});
    
  const {t} = useTranslation();

  const style = {
    card: {
      display: 'flex',
      width: '90%',
      paddingX: '.2em',
    },
    cardContent: {
      display: 'flex',
      width: '100%'
    },
    labelCard: {
      fontSize: '1.1em'
    },
    labelPart: {
      fontSize: '0.8em',
    }
  };

  useEffect(() => {
    setSectionProperties(selectedSection.properties);
  }, [selectedSection]);

  const RowInfo = ({label, children}) => {
    return (
      <Stack sx={{display: 'flex', width: '100%', alignItems: 'center'}} component='li' spacing={2} direction='row'>
        <Typography sx={style.labelPart}>
          {label} :
        </Typography>
        {children}
      </Stack>
    );
  };

  const calcWidth = value => {
    const valueNumber = Number(value).toFixed(1);
    if (valueNumber > 2) {
      return t('stepPath.more_2');
    } else {
      return `${valueNumber} m`;
    }
  };

  const renderInfo = () => {
    return (
      <Stack sx={{ display: 'flex', width: '100%', paddingLeft: 0, paddingRight: 0 }} component='ul' spacing={2} direction='column'>
        {sectionProperties.name && (
          <Box sx={{display: 'flex', width: '100%'}} component='li'>
            <Typography sx={style.labelCard}>
              {sectionProperties.name}
            </Typography>
          </Box>
        )}
        <Typography sx={style.labelPart}>
          {sectionProperties.instruction ?? t('stepPath.label-unknown')}
        </Typography>
        <RowInfo label={t('stepPath.label-access')}>
          <AccBadge acc={sectionProperties.acc} typeAcc={typeAcc} />
        </RowInfo>
        <RowInfo label= {t('stepPath.label-length')}>
          <LengthBadgeFeature feature={selectedSection} />
        </RowInfo>
        {sectionProperties.su && (
          <RowInfo label= {t('stepPath.label-coating')}>
            <Typography sx={style.labelPart}>
              {sectionProperties.su ? t(`${labelCnigSurface(sectionProperties.su)}`) : t('stepPath.label-unknown')}
            </Typography>
          </RowInfo>
        )}
        {sectionProperties.co && (
          <RowInfo label= {t('stepPath.label-condition')}>
            <Typography sx={style.labelPart}>
              {sectionProperties.co ? t(`${labelCnigCondition(sectionProperties.co)}`) : t('stepPath.label-unknown')}
            </Typography>
          </RowInfo>
        )}
        {sectionProperties.w && (
          <RowInfo label={t('stepPath.label-width')}>
            <Typography sx={style.labelPart}>
              {sectionProperties.w ? calcWidth(sectionProperties.w) : t('stepPath.label-unknown')}
            </Typography>
          </RowInfo>
        )}
        {sectionProperties.s && (
          <RowInfo label={t('stepPath.label-tilt')}>
            <Typography sx={style.labelPart}>
              {sectionProperties.s ? `${Number(sectionProperties.s).toFixed(1)} °` : t('stepPath.label-unknown')}
            </Typography>
          </RowInfo>
        )}
      </Stack>
    );
  };

  return (
    <Card sx={style.card}>
      <CardContent sx={style.cardContent}>
        {renderInfo()}
      </CardContent>
    </Card>
  );
};